<template>
    
    <div>    
       <!--  <p>Id ES {{$route.params.id}}</p> -->
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a>
                    <router-link :to="{name:'r-/'}">Inicio</router-link>
                </a></li>
                <li class="breadcrumb-item active" aria-current="page">Compras</li>
                <li class="breadcrumb-item active li-actualizar-datos" aria-current="page" title="Actualizar datos de compra" v-if="general.otros.app_modo=='online'" @click=obtener_recursos>
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                </li>
            </ol>
        </nav>
        <div>
            <!---<input type="text" @keydown=evento_teclas id="input-evento-tecla-enter">-->                   
            <div class="row">
                
                <div class="col-12 mt-4">
                    <div class="card">
                        <div class="card-body" style="display:flex; flex-wrap: wrap;">
                            
                            <div style="width: 100%; display:flex; justify-content:space-evenly;">
                                <button type="button" class="boton-3d-success" @click=boton_modal_registro>
                                    Nueva compra
                                </button>

                                <!-- <button  v-if="general.otros.app_modo=='online'" type="button" class="boton-3d-info" @click=obtener_recursos>
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                </button> -->
                            </div>       
                            <div v-if="datos.data_table.cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:white;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>     
                            <div id="contenedor-tabla-registros" style="width: 100%;">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>










        <!-- inicio modal registro -->
        <div class="modal fade bd-example-modal-lg" id="modal-registro" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-xl" style="width:95%;">
                <div class="modal-content modal-3d">
                    <div class="modal-header">
                        <template v-if="['','activo'].includes(datos.registro.estado)">
                            <h5 v-if="datos.registro.id===''" class="modal-title">Crear compra</h5>
                            <h5 v-else class="modal-title">Editar compra</h5>
                        </template>
                        <template v-else>
                            <h5>Datos de la compra</h5>
                        </template>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">                                
                                
                                <!---<div class="form-group col-md-12">
                                    <label for="inputEmail4">Cliente:</label>                                    
                                    <select class="form-control input-3d" v-model=datos.registro.clientes_id @change="cliente_seleccionado('')">
                                        <option value="" disabled>Seleccione</option>

                                        <option v-for='(c,c_index) in datos.clientes.todos' :key=c_index :value=c.id>
                                            {{ c.nombre }} {{c.apellido_paterno}} {{c.apellido_materno}} -
                                            
                                            <template v-if="c.tipo=='ambos'"> 
                                                Mayoreo y Menudeo
                                            </template>
                                            <template v-else>
                                                {{c.tipo}}
                                            </template>
                                            
                                        </option>

                                    </select>
                                </div>-->                                                                                                                                                                

                                <div class="form-group col-md-12">
                                    <label for="inputEmail4">Materiales de la compra:</label>                                    
                                    <div>                                        
                                        

                                        <div style="width:100%;">

                                            <template v-for='(item,index) in datos.registro.productos' :key=index>
                                                <div v-if="item.estado=='activo'" class="form-row contenedor-producto">  
                                                    
                                                    <div class="form-group col-md-12" style="margin:0px;">

                                                        <div class="form-row">  

                                                            <!-- <div class="form-group col-md-1 col-1">
                                                                <div style="height:100%; width:100%; display:flex; justify-content:center; align-items:center;">
                                                                    <label for="inputEmail4">{{item.posicion}}</label>
                                                                </div>
                                                            </div> -->
                                                            <div class="form-group col-md-11 col-11">

                                                                <div class="form-row">
                                                                    <div class="form-group col-md-4 col-11">

                                                                        <div v-if="item.productos_id==''">
                                                                            <label for="inputEmail4" class="titulo-campo">Material:</label>
                                                                            <select class="form-control input-3d" :id="'select_material_'+index" data-live-search="true" v-model=item.productos_id @change=material_seleccionado(index)>
                                                                                <option value="" disabled>Seleccione</option>
                                                                                <option v-for='(p,p_index) in datos.productos.todos' :key=p_index :value=p.id>
                                                                                    {{p.nombre}}
                                                                                </option>                            
                                                                            </select>
                                                                        </div>
                                                                        <div v-else style="height:100%; width:100%; display:flex; flex-wrap:wrap; align-items:center;">
                                                                            <label for="inputEmail4" class="titulo-campo">Material:</label>
                                                                            <template v-for='(p,p_index) in datos.productos.todos'>
                                                                                <p v-if="p.id==item.productos_id" :key=p_index class="material-nombre" @click="regresar_selecionar_producto(index)" style="width:100%; text-align:center;">
                                                                                    {{p.nombre}}
                                                                                </p>
                                                                            </template>
                                                                        </div>
                                                                        
                                                                    </div>
                                                                    <div class="form-group col-md-2 col-5">
                                                                        <label for="inputEmail4" class="titulo-campo">Cantidad (Kg):</label>                                                            
                                                                        <input type="number" :id="'input_cantidad_'+index" class="form-control input-3d valor-campo" v-model=item.cantidad @input=calcular_producto_total(index) @keydown=cantidad_evento_key($event,index)>
                                                                    </div>
                                                                    <div class="form-group col-md-2 col-4">
                                                                        <label for="inputEmail4" class="titulo-campo">Precio:</label>
                                                                        <input type="number" :id="'precio_cantidad_'+index" class="form-control input-3d valor-campo" v-model=item.precio @input=calcular_producto_total(index) @keydown=precio_evento_key>
                                                                    </div>
                                                                    <div class="form-group col-md-2 col-3">                                                                
                                                                        <label for="inputEmail4" class="titulo-campo">Total:</label>                                                            
                                                                        <p class="material-total valor-campo"> {{formato_moneda(item.total)}} </p>
                                                                    </div>
                                                                </div>
                                                            <!-- <div class="form-group col-md-2 col-12" style="display:flex; align-items:center;">                                                                
                                                                <input type="checkbox" class="form-control" v-model=item.inventariar>
                                                            </div> -->
                                                            </div>


                                                            <div class="form-group col-md-1 col-1" style="display:flex; align-items:start;">                                                            
                                                                <button class='boton-3d-danger' v-if="['','activo'].includes(datos.registro.estado)" @click="boton_remover_producto(index)">
                                                                    <i class='fa fa-times' aria-hidden='true'></i>
                                                                </button>
                                                            </div>


                                                        </div>
                                                        
                                                    </div>                                                                                                                                                                                                        

                                                </div>
                                            </template>

                                        </div>
                                    </div>


                                    <!--<button type="button" class="boton-3d-success" v-if="['','activo'].includes(datos.registro.estado) && datos.registro_cargando==false" @click="agregar_producto('')">
                                        <i class='fa fa-plus' aria-hidden='true'></i>    
                                        Agregar material
                                    </button>-->

                                </div> 
                                
                                <div class="form-group col-md-4">
                                    <button type="button" class="boton-3d-success" v-if="['','activo'].includes(datos.registro.estado) && datos.registro_cargando==false" @click="agregar_producto('')">
                                        <i class='fa fa-plus' aria-hidden='true'></i>    
                                        Agregar material
                                    </button>
                                </div>
                                <div class="form-group col-md-8">
                                    <label for="inputEmail4">Cliente:</label>                                    
                                    <select class="form-control input-3d" v-model=datos.registro.clientes_id @change="cliente_seleccionado('')" disabled>
                                        <option value="" disabled>Seleccione</option>

                                        <option v-for='(c,c_index) in datos.clientes.todos' :key=c_index :value=c.id>
                                            {{ c.nombre }} {{c.apellido_paterno}} {{c.apellido_materno}} -
                                            
                                            <template v-if="c.tipo=='ambos'"> 
                                                Mayoreo y Menudeo
                                            </template>
                                            <template v-else>
                                                {{c.tipo}}
                                            </template>
                                            
                                        </option>

                                    </select>
                                </div>
                                
                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Total de compra :</label>
                                    <p style="font-size:2em;"> {{  formato_moneda(datos.registro.total_compra_pre1) }} </p>                                                                        
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Forma de pago:</label>
                                    <select class="form-control input-3d" v-model=datos.registro.forma_pago @change="forma_pago_seleccionado" disabled>
                                        <option value="" disabled>Seleccione</option>
                                        <option value="efectivo">Efectivo</option>
                                        <!-- <option value="transferencia">Transferencia</option>
                                        <option value="efectivo_transferencia">Ambos</option> -->
                                    </select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label for="inputEmail4">Fecha de creación:</label> 
                                    <input type="date" class="form-control input-3d" v-model=datos.registro.fecha_creacion>
                                </div>

                                <template v-if="datos.registro.forma_pago=='efectivo_transferencia'">
                                    <div class="form-group col-md-4">
                                        <label for="inputEmail4">Cantidad efectivo:</label>
                                        <input type="number" class="form-control input-3d" v-model=datos.registro.forma_pago_efe_tra_cant_efec @input="calcular_forma_pago_efec_tran_total">
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label for="inputEmail4">Cantidad transferencia:</label>
                                        <input type="number" class="form-control input-3d" v-model=datos.registro.forma_pago_efe_tra_cant_tran @input="calcular_forma_pago_efec_tran_total">                                        
                                    </div>
                                    <div class="form-group col-md-12" v-if="(datos.registro.productos).length>0">
                                        <p v-if="datos.forma_pago_efec_tran_cantidad_valida" id="leyenda-metodo-pago-ambos-verde">Cantidad en efectivo + transferencia correcto</p>
                                        <p v-else id="leyenda-metodo-pago-ambos-rojo">Cantidad en efectivo + transferencia debe ser igual al total final</p>
                                    </div>
                                </template>
                                                                                                                                                                          
                                
                            </div>  

                            <div class="form-row" v-if="['transferencia','efectivo_transferencia'].includes(datos.registro.forma_pago)">

                                <div class="form-group col-md-6 col-12">
                                    <template v-if="['','activo'].includes(datos.registro.estado)">

                                        <label for="inputEmail4">Cuentas Disponibles :</label>                                    
                                        <select id="select_cuentas_disponibles" class="form-control input-3d" v-model=datos.cuentas_bancarias.seleccionado @change="cuenta_bancaria_seleccionado('')">
                                            <option value="" disabled>Seleccione</option>
                                            <option v-for='(c,c_index) in datos.cuentas_bancarias.todos' :key=c_index :value="c.cuentas_bancarias_id">
                                                {{ c.banco_nombre }}
                                                {{ c.cuenta }}
                                                {{ c.titular }}
                                            </option>
                                        </select>

                                    </template>

                                </div>

                                <div class="form-group col-md-6 col-12"></div>

                                <div class="form-group col-md-10 col-12">
                                    <label for="inputEmail4">Cuentas seleccionadas :</label>                                    
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Banco</th>
                                                <th scope="col">Cuenta</th>
                                                <th scope="col">Titular</th>
                                                <th scope="col">Cantidad a transferir</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for='(c,c_index) in datos.registro.transferencias'>

                                                <tr v-if="c.estado=='activo'" :key=c_index>

                                                    <th scope="row">{{c_index+1}}</th>
                                                    <td>                                                         
                                                        {{ c.banco_nombre }}
                                                    </td>
                                                    <td>{{ c.cuenta }}</td>
                                                    <td>{{ c.titular }}</td>
                                                    <td>

                                                        <div class="contenedor-check-cantidad">        

                                                            <template v-if="['','activo'].includes(datos.registro.estado)">
                                                                <input :id="'input_cuenta_cantidad_'+c_index" type="number" class="form-control input-3d" v-model=c.cantidad>
                                                            </template>
                                                            <template v-else>
                                                                <input :id="'input_cuenta_cantidad_'+c_index" type="number" class="form-control input-3d" :value=c.cantidad disabled>
                                                            </template>

                                                        </div>

                                                    </td>
                                                    <td>

                                                        <button v-if="['','activo'].includes(datos.registro.estado)" class='boton-3d-danger' type="button" @click=remover_transferencia(c_index)>
                                                            <i class='fa fa-times' aria-hidden='true'></i>
                                                        </button>
                                                    </td>

                                                </tr>
                                            </template>

                                        </tbody>
                                    </table>
                                </div>

                            </div>  


                        </div>
                    </div>
                    <div class="modal-footer" id="modal-compras-footer">
                        <div id="modal-compras-footer-imprimir">
                            <input type="checkbox" class="form-control" v-model=datos.imprimir_ticket_al_finalizar>
                            <p>Imprimir ticket al finalizar</p>
                        </div>
                        <div id="modal-compras-footer-botones">
                            <template v-if="['','activo'].includes(datos.registro.estado) && datos.registro_cargando==false">
                                
                                <template v-if="general.otros.app_modo=='offline'">
                                    <button type="button" class="boton-3d-success" @click="guardar_localmente">
                                        Guardar localmente
                                    </button> 
                                </template>
                                <template v-if="general.otros.app_modo=='online'">
                                    <button type="button" class="boton-3d-success" @click="enviar_datos('finalizar')">
                                        Finalizar compra
                                    </button> 
                                    <button type="button" class="boton-3d-success" @click="enviar_datos('guardar')">
                                        <template v-if="datos.registro.id===''">Guardar compra</template>
                                        <template v-else>Guardar compra</template>
                                    </button>
                                </template>

                            </template>
                            <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>

                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->


        <!-- inicio modal enviar -->
        <div class="modal fade bd-example-modal-lg" id="modal-enviar">
            <div class="modal-dialog modal-lg">
                <div class="modal-content modal-3d">
                    <div class="modal-header">                        
                        <h5>Enviar datos de la compra no : {{datos.enviar_ticket.datos.no}}</h5>
                        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div v-if="datos.registro_cargando" class="d-flex justify-content-center" style="width:100%; margin-top:1em; margin-bottom:1em; color:black;">
                                <div class="spinner-border" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div class="form-row">

                                <div class="form-group col-md-12">
                                    <div class="form-row">
                                        <div class="form-group col-md-12">
                                            <label for="inputEmail4">Cliente:</label>                                    
                                            <p>
                                                {{datos.enviar_ticket.datos.cliente_nombre}}
                                                {{datos.enviar_ticket.datos.cliente_apellido_paterno}}
                                                {{datos.enviar_ticket.datos.cliente_apellido_materno}}
                                            </p>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputEmail4">Telefono:</label>                                    
                                            <p style="color:red;" v-if="datos.enviar_ticket.datos.telefono===''">
                                                Es necesario el telefono del cliente
                                            </p>
                                            <p v-else>
                                                {{datos.enviar_ticket.datos.telefono}}
                                            </p>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputEmail4">Dirección:</label>                                    
                                            <p>
                                                {{datos.enviar_ticket.datos.direccion}}
                                            </p>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="inputEmail4">Total de la compra:</label>                                    
                                            <p>
                                                {{ formato_moneda(datos.enviar_ticket.datos.total_compra) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>                           
                                <!---<div class="form-group col-md-6">                                   
                                    <iframe :src=datos.enviar_ticket.datos.ticket_url height="400" width="100%" title="Ticket de compra"></iframe>
                                </div>-->                                                                                                                                                       

                                
                            </div>                          
                        </div>
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="boton-3d-success" v-if="datos.enviar_ticket.datos.telefono!==''" @click=enviar_ticket>
                            Enviar ahora
                        </button>
                        <button type="button" class="boton-3d-danger" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
        <!---fin modal registro---->

        <div style="position:absolute; width:21.59cm; left:-1000px; display:none;" id="contenedor-impresion-ticket">
            
        </div>



        

            
    </div>

</template>

<script>
/* eslint-disable */
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Swal   from '@/librerias/sweetalert2_9/sweetalert2_9.js'
import * as calculos  from '@/librerias/lobato-calculos.js'
import PouchDB  from '@/librerias/pouchdb/pouchdb.min.js'

//import '@/librerias/select-buscador/select-buscador.min.css'
//import '@/librerias/select-buscador/select-buscador.min.js'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
    return {
        datos:{
            registro_cargando:false,
            registro:{
                _id:'',
                id:'',
                clientes_id:'',
                fecha_creacion:'',
                prestamos:[],
                productos:[],
                total_compra_pre1:'',
                total_compra:'',
                forma_pago:'',
                forma_pago_efe_tra_cant_efec:'',
                forma_pago_efe_tra_cant_tran:'',

                transferencias:[],

                estado:''          
            },
            forma_pago_efec_tran_cantidad_valida:false,
            productos:{
                todos:[]
            },
            clientes:{
                todos:[],
                prestamos:{
                    todos:[],
                    seleccionado:'',
                    cargando:false
                }
            },
            cuentas_bancarias:{
                todos:[],
                seleccionado:''
            },
            enviar_ticket:{
                datos:{
                    cliente_nombre:'',
                    cliente_apellido_paterno:'',
                    cliente_apellido_materno:'',
                    direccion:'',
                    fecha_creacion:'',
                    hora_creacion:'',
                    no:'',
                    telefono:'',
                    total_compra:'',

                    compras_clave_visualizar:'',
                    ticket_url:'',
                    productos:[],
                    prestamos:[]
                }
            },
            data_table:{
                cargando:false,
                registros:[]
            },
            imprimir_ticket_al_finalizar:true
        }
    }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
        //...mapActions(['formato_moneda']),
        regresar_selecionar_producto(index)
        {
            this.datos.registro.productos[index].productos_id='';
            this.actualizar_select_material(index,'');
        },
        inicial()
        {
            if(this.general.otros.autenticado===true)
            {
                this.eventos();
                this.obtener_recursos();
                //this.data_table();

            }
            else if(this.general.otros.autenticado===false)
            {
                this.$router.push('/login');
            }
        }, 
        eventos()
        {
            //console.log('evento es');
            //document.getElementById("input-evento-tecla-enter").focus();
            /* Array.from(document.getElementsByClassName("input-3d")).forEach((item)=>{
                item.addEventListener('wheel',(event)=>{
                    event.preventDefault(); // evita que el scroll cambie el valor
                });
            }); */

            /* const input = document.getElementById("input-3d");
            input.addEventListener("wheel", function(event) {
                event.preventDefault(); // evita que el scroll cambie el valor
            }); */
        }, 
        obtener_recursos()
        {
            this.datos.data_table.cargando=true;
            fetch(`${this.general.otros.dominio_server}/compras/recursos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',  
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                console.log('recursos');
                console.log(respuesta);
                this.datos.productos.todos  =respuesta.datos.productos;
                this.datos.clientes.todos   =respuesta.datos.clientes;

                this.datos.cuentas_bancarias.todos  =respuesta.datos.cuentas_bancarias;

                this.data_table();

            })
            .catch(error=>{
                this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                this.datos.data_table.cargando=false;                
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },    
        boton_modal_registro()
        {
            for (const p in this.datos.registro) {                    
                
                if(p=='productos')
                {
                    this.datos.registro[p]=[];
                }
                else if(p=='transferencias')
                {
                    //this.asignar_cuentas();
                    this.datos.registro[p]=[];
                }
                else if(p=='prestamos')
                {
                    this.datos.registro[p]=[];
                }
                else if(p=='forma_pago')
                {
                    this.datos.registro[p]='efectivo';
                }
                else if(p=='clientes_id')
                {
                    this.datos.registro[p]=21;
                }
                else
                {
                    this.datos.registro[p]='';
                }
                
            }  
            
            this.datos.clientes.prestamos.todos=[];
            this.datos.clientes.prestamos.seleccionado='';
    
            /*let fechaActual = new Date();
            let ano = fechaActual.getFullYear();

            let mes = fechaActual.getMonth() + 1;
            mes=mes<10 ? `0${mes}` : mes;

            let dia = fechaActual.getDate();
            dia=dia<10 ? `0${dia}` : dia;

            let fecha = `${ano}-${mes}-${dia}`;
            this.datos.registro.fecha_creacion=fecha;*/
            this.datos.registro.fecha_creacion=this.general_fecha_hoy;

            this.datos.registro.forma_pago_efe_tra_cant_efec='';
            this.datos.registro.forma_pago_efe_tra_cant_tran='';
            this.datos.forma_pago_efec_tran_cantidad_valida=false;

            this.datos.imprimir_ticket_al_finalizar=true;

            document.getElementById('contenedor-impresion-ticket').innerHTML=``;

            this.cliente_seleccionado('');
        

            
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.abrir});
            $("#modal-registro").modal("show");
            
        },
        data_table()
        {
            this.datos.data_table.cargando=true;        
            /* if(this.general.otros.app_modo=='offline')
            {                
                this.obtener_registros_offline();
            }   
            else if(this.general.otros.app_modo=='online')
            {  */               
                this.obtener_registros_offline();
            //}
        },
        data_table_crear()
        {
            this.datos.data_table.cargando=false;
            document.getElementById('contenedor-tabla-registros').innerHTML=`
                <table id="tabla-registros" class="table table-hover w-100 pb-30">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Cliente</th>
                            <th>Total compra</th>
                            <th>Fecha creación</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody >
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>No</th>
                            <th>Cliente</th>
                            <th>Total compra</th>
                            <th>Fecha creación</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </tfoot>
                </table>
            `;
            $('#tabla-registros thead tr').clone(true).appendTo( '#tabla-registros thead' );
            $('#tabla-registros thead tr:eq(1) th').each( function (i) {
                var title = $(this).text();
                $(this).html( '<input class="form-control" style="width:100%;font-size:11px;" type="text" placeholder="Buscar '+title+'" />' );
        
                $( 'input', this ).on( 'keyup change', function () {
                    if ( tabla_registros.column(i).search() !== this.value ) {
                        tabla_registros
                            .column(i)
                            .search( this.value )
                            .draw();
                    }
                } );
            } );
            
            var tabla_registros=$('#tabla-registros').DataTable({
                orderCellsTop: true,
                fixedHeader: true,
                responsive: true,
                autoWidth: true,
                "order":[0,'desc'],
                language: {
                    search: "Buscar",
                    searchPlaceholder: "Buscar",
                    lengthMenu: "Mostrando _MENU_ registros por página",
                    zeroRecords: "No se encontraron registros",
                    info: "Mostrando pagina _PAGE_ de _PAGES_",
                    infoEmpty: "No hay registros disponibles",
                    infoFiltered: "(filtrando de _MAX_ registros)",
                    paginate: {
                        "first":      "First",
                        "last":       "Last",
                        next:       "Siguiente",
                        previous:   "Anterior"
                    },
                },
                //ajax:`/ordenes_elaboracion_materiales/todos`,
                //ajax:`/clientes/todos`,
                data:this.datos.data_table.registros,                
                columnDefs:[
                    {"targets":0, "data":function(data,type,full,meta)
                        {           
                            let no='';
                            if(data.registro_origen=='online')                 
                            {
                                no=data.no;
                            }
                            return  no;
                        }
                    }, 
                    {"targets":1, "data":(data,type,full,meta)=>
                        {
                            if(data.registro_origen=='online')
                            {
                                let a={
                                    nombre:[null,''].includes(data.nombre) ? '' : data.nombre,
                                    apellido_p:[null,''].includes(data.apellido_paterno) ? '' : data.apellido_paterno,
                                    apellido_m:[null,''].includes(data.apellido_materno) ? '' : data.apellido_materno
                                };
                                return `${a.nombre} ${a.apellido_p} ${a.apellido_m}`;
                            }
                            else if(data.registro_origen=='offline')
                            {
                                let c=(this.datos.clientes.todos).find((e)=>e.id==data.clientes_id);
                                //console.log('CLIENTE----------------------------------------');
                                //console.log(c);
                                if(c!==undefined)
                                {
                                    let a={
                                        nombre      :[null,''].includes(c.nombre) ? '' : c.nombre,
                                        apellido_p  :[null,''].includes(c.apellido_paterno) ? '' : c.apellido_paterno,
                                        apellido_m  :[null,''].includes(c.apellido_materno) ? '' : c.apellido_materno
                                    };
                                    return `${a.nombre} ${a.apellido_p} ${a.apellido_m}`;
                                }
                                else
                                {
                                    return '';
                                }
                            }
                            else
                            {
                                return '';
                            }
                        }
                    },                    
                    {"targets":2, "data":(data,type,full,meta)=>
                        {
                            return this.formato_moneda(data.total_compra);
                        }   
                    },
                    {"targets":3, "data":(data,type,full,meta)=>
                        {
                            return data.fecha_creacion;                           
                        }   
                    },
                    {"targets":4, "data":(data,type,full,meta)=>
                        {
                            if(data.registro_origen=='online')
                            {
                                return data.estado;
                            }
                            else if(data.registro_origen=='offline')
                            {
                                return 'no guardado';
                            }
                            else
                            {
                                return '';
                            }
                        }   
                    },
                    {"targets":5, "data":(data,type,full,meta)=>
                        {
                            var acciones=``;
                            //let boton_editar_ver=data.estado=='activo' ? 'Editar' : 'Ver datos';

                            if(data.registro_origen=='online')
                            {    
                                let boton_editar_ver='';
                                if(data.estado=='activo')
                                {
                                    boton_editar_ver=`
                                        <i registro-id='${data.id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        Editar
                                    `;
                                }
                                else
                                {
                                    boton_editar_ver=`
                                        <i registro-id='${data.id}' class="fa fa-eye" aria-hidden="true"></i>
                                        Ver datos
                                    `;
                                }                            

                                acciones+=`                                
                                    <a href="${this.general.otros.dominio}/#/compras/${data.clave_visualizar}/ticket" target="_blank" class="boton-3d-info" style="margin-right:1em;">                                                                            
                                        Ticket
                                    </a>
                                    <button registro-id='${data.id}' registro-no='${data.no}' class="boton-modal-remover boton-3d-danger" style="margin-right:1em;">
                                        <i registro-id='${data.id}' registro-no='${data.no}' class='fa fa-times' aria-hidden='true'></i>                                    
                                    </button>
                                    <!--<button registro-id='${data.id}' class="boton-modal-enviar boton-3d-info" style="margin-right:1em;">
                                        <i registro-id='${data.id}' class="fa fa-paper-plane" aria-hidden="true"></i>
                                    </button>-->
                                    <button registro-id='${data.id}' class="boton-modal-editar-registro boton-3d-success" style="margin-right:1em;">                                    
                                        ${boton_editar_ver}
                                    </button>
                                `;
                            }
                            else if(data.registro_origen=='offline')
                            {
                                acciones+=`
                                    <button registro-id='${data._id}' class="boton-modal-editar-registro-offline boton-3d-success" style="margin-right:1em;">
                                        <i registro-id='${data._id}' class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                        Editar
                                    </button>

                                    <a href="${this.general.otros.dominio}/#/compras/local_${data._id}/ticket" target="_blank" class="boton-3d-info" style="margin-right:1em;">                                                                            
                                        Ticket
                                    </a>
                                `;

                            }   
                            

                            return `
                                <div style="display:flex; justify-content:left; align-items:center;">
                                    ${acciones} 
                                </div>
                            `;
                        }
                    }
                ],
                "drawCallback": this.eventos_data_table
            });
            tabla_registros.on( 'responsive-display',  ( e, datatable, row, showHide, update ) => {               
                this.eventos_data_table();
            } );
            
        },
        eventos_data_table()
        {
            Array.from(document.getElementsByClassName("boton-modal-editar-registro")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_evento);
            });
            
            Array.from(document.getElementsByClassName("boton-modal-remover")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_remover);
            });

            Array.from(document.getElementsByClassName("boton-modal-enviar")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_enviar);
            });

            Array.from(document.getElementsByClassName("boton-modal-editar-registro-offline")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_editar_registro_offline_evento);
            });

            Array.from(document.getElementsByClassName("boton_modal_subir")).forEach((item)=>{
                item.addEventListener('click',this.boton_modal_subir);
            });
        },
        boton_modal_editar_registro_offline_evento(item)
        {
            this.boton_modal_registro();  
            ///this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;  
            this.datos.registro.fecha_creacion='';  
            this.datos.registro.forma_pago='';  
            this.datos.registro.clientes_id='';

            let _id=calculos.atributo(item,'registro-id');
            let r=this.datos.data_table.registros.find( (e)=> e._id==_id );
            console.log('compra offline es');
            console.log(r);
            if(r!=undefined)
            {
                let c=this.datos.registro;
                c._id                         =_id;
                c.id                          =r.id;
                c.clientes_id                 =r.clientes_id;
                c.fecha_creacion              =r.fecha_creacion;
                c.prestamos                   =r.prestamos;
                c.productos                   =r.productos;
                c.total_compra_pre1           =r.total_compra_pre1;
                c.total_compra                =r.total_compra;
                c.forma_pago                  =r.forma_pago;
                c.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                c.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;
                c.transferencias              =r.transferencias;
                c.estado                      =r.estado;

                /* r.productos.forEach((item,index)=>{
                    item.inventariar=item.inventariar==='si' ? true : false;
                    this.agregar_producto(item);
                }); */

                this.cliente_seleccionado('db');

                /* r.prestamos.forEach((item,index)=>{
                    this.prestamo_seleccionado(item);
                }); */

                this.calcular_forma_pago_efec_tran_total();
            }
            this.datos.registro_cargando=false;  
        },
        obtener_registros_offline()
        {
            this.datos.data_table.registros=[];
            let db = new PouchDB('metales_milenio_2024_compras');            
            db.allDocs({include_docs: true})
            .then(doc=>{                

                let registros=[];
                //console.log('rows son ');
                //console.log(doc.rows);
                doc.rows.forEach((row)=>{

                    let doc=row.doc;
                    //console.log('docu es');
                    //console.log(doc)
                    if(!doc.sincronizado)
                    {
                        //this.datos.data_table.registros.push(doc);
                        doc.registro_origen='offline';
                        //console.log('registro local');
                        //console.log(doc);
                        //doc.id=doc._id;

                        registros.push(doc);
                    }

                });
                //this.datos.data_table.registros=this.datos.data_table.registros.reverse();
                //this.datos.data_table.registros=registros.reverse();
                registros=registros.reverse();
                registros.forEach((item)=>{
                    this.datos.data_table.registros.push(item);
                });
                if(this.general.otros.app_modo=='online')
                {                
                    this.obtener_registros_online();
                }
                else
                {
                    this.data_table_crear();
                    //this.datos.data_table.cargando=false;     
                }

            })
            .finally( () => {
                //this.datos.data_table.cargando=false;     

            });
        },
        obtener_registros_online()
        {
            fetch(`${this.general.otros.dominio_server}/compras/todos`,{
                method:'GET',
                //body:JSON.stringify( this.datos.registro ),
                headers:{
                    'Accept'        :'application/json',
                    'Content-Type'  :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{
                
                (respuesta.datos).forEach((item)=>{
                    item.registro_origen='online';
                    item._id='';
                    this.datos.data_table.registros.push(item);
                });
                //this.datos.data_table.registros=respuesta.datos;                
                this.data_table_crear();
            })
            .catch(error=>{
                //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los clientes`});
            })
            .finally( () => {
                //this.datos.data_table.cargando=false;                
            });
        },
        boton_modal_enviar(item)
        {
            this.datos.registro.id=calculos.atributo(item,'registro-id');
            this.datos.registro_cargando=true;

            for (const p in this.datos.enviar_ticket.datos) {                                                    
                this.datos.enviar_ticket.datos[p]='';                                
            } 

            fetch(`${this.general.otros.dominio_server}/compras/${this.datos.registro.id}/enviar_ticket/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                let r=respuesta.datos.compra[0];                
                console.log(r);
                //this.datos.enviar_ticket.datos.compras_clave_visualizar=r.compras_clave_visualizar;

                this.datos.enviar_ticket.datos.cliente_nombre=r.cliente_nombre;
                this.datos.enviar_ticket.datos.cliente_apellido_paterno=r.cliente_apellido_paterno;
                this.datos.enviar_ticket.datos.cliente_apellido_materno=r.cliente_apellido_materno;
                this.datos.enviar_ticket.datos.telefono=[null,''].includes(r.telefono) ? '' : r.telefono;
                this.datos.enviar_ticket.datos.direccion=r.direccion;
                this.datos.enviar_ticket.datos.no=r.no;
                this.datos.enviar_ticket.datos.total_compra=r.total_compra;
                this.datos.enviar_ticket.datos.fecha_creacion=r.fecha_creacion;
                this.datos.enviar_ticket.datos.hora_creacion=r.hora_creacion;
                //this.datos.enviar_ticket.datos.ticket_url=`${this.general.otros.dominio_server}/publico/compras/${r.compras_clave_visualizar}/ticket`;
                this.datos.enviar_ticket.datos.productos=r.productos;
                this.datos.enviar_ticket.datos.prestamos=r.prestamos;

            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            $("#modal-enviar").modal('show');

        },
        enviar_ticket()
        {
            var numero = this.datos.enviar_ticket.datos.telefono;
            /* var mensaje = `
                Hola, estos son los detalles de su venta :  
                ${this.datos.enviar_ticket.datos.ticket_url}
                ¡Gracias por su compra!
            `; */
            var mensaje = 'Hola, estos son los detalles de su venta : \n \n \n';

            mensaje = mensaje+`Fecha de venta : ${this.datos.enviar_ticket.datos.fecha_creacion} \n`;
            mensaje = mensaje+`Hora de venta : ${this.datos.enviar_ticket.datos.hora_creacion} \n \n \n`;


            mensaje = mensaje+'Materiales: \n \n';
            
            this.datos.enviar_ticket.datos.productos.forEach((p,index)=>{
                mensaje=mensaje+`${p.cantidad} Kg - ${p.producto_nombre} - Precio : ${ this.formato_moneda(p.precio) } - Total : ${ this.formato_moneda(p.total) } \n \n`;
            });

            if(this.datos.enviar_ticket.datos.prestamos.length>0)
            {
                mensaje = mensaje+'\nPrestamos: \n \n'; 
                this.datos.enviar_ticket.datos.prestamos.forEach((p,index)=>{
                    mensaje=mensaje+`Prestamo : $${ this.formato_moneda( p.cantidad ) } - Abono : $${ this.formato_moneda(p.abono) }  \n \n`;
                });
            }

            mensaje = mensaje+`\nTotal compra: ${this.formato_moneda( this.datos.enviar_ticket.datos.total_compra )} \n\n`;

            mensaje=mensaje+'! Gracias por su venta !';

            var url = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensaje); 
            window.open(url, '_blank');             


            //token de envio de mensaje api whatssap
            /*
            const accessToken = 'EAAMFhAPDj7IBO0ZA6ZBTMOVu2RqY95FMosrBGB1sdGOksLzLGa3rqKmPl42TvVtZCJsvhgTl6ZCGoNHhvKme0ZA71KoMdFdQngKRedIU2RjBYMQUFgDq1C3ZAuyECskGp3yTOd8lgqmPCZCveZBsxZBCZB0MzfXeQpZCH1ZCojK4g6UrlM1GuDy5ZBUZCTZCqXjRuoAZCaaMgMZBgtYbZBDZCMZC7YKZA5FZAKqalDob3T';
            const phoneNumber = this.datos.enviar_ticket.datos.telefono; //'NUMERO_DE_TELEFONO_DEL_DESTINATARIO'; 
            const imageUrl = 'https://milenio.i-deasmx.com/img/vertab1.bc815edb.jpg';//'URL_DE_LA_IMAGEN'; 
            const caption = 'Hola, le enviamos el ticket de su venta :';
                       
            const id_whattssap_busines ='553042371221196';
            fetch(`https://graph.facebook.com/v21.0/${id_whattssap_busines}/messages`, { 
                method: 'POST', 
                headers: { 
                    'Content-Type': 'application/json', 
                    'Authorization': `Bearer ${accessToken}` }, 
                    body: JSON.stringify({ 
                        messaging_product: 'whatsapp', 
                        to: '52'+phoneNumber, 
                        type: 'image', 
                        //type:'template',
                        template:{
                            name:'hello_world',
                            language:{
                                code:'en_US'
                            }
                        }
                        // image: { 
                        //     link: imageUrl, 
                        //     caption: caption 
                        // } 
                    }) 
                })
            .then(response => response.json()) 
            .then(data => { 
                console.log('Mensaje con imagen enviado con éxito:', data); 
            })
            .catch(error => { 
                console.error('Error al enviar el mensaje:',error);
            });
            */
        },
        boton_modal_remover(item)
        {
            //this.datos.registro.i
            let dt={
                id:calculos.atributo(item,'registro-id'),
                no:calculos.atributo(item,'registro-no')
            };
            Swal.fire({
                title: `¿ Remover compra no : ${dt.no} ?`,
                text: "",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Si, remover ahora",
                cancelButtonText:'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) 
                {
                    this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                    fetch(`${this.general.otros.dominio_server}/compras/registro/remover`,{
                        method:'POST',
                        body:JSON.stringify( {
                            compras_id:dt.id,
                        } ),
                        headers:{                    
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                            'Content-Type'  :'application/json',
                            'Accept'        :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                        },
                        credentials: 'include',                   
                    })
                    //.then(res=>res.json())
                    .then(res => {
                        //console.log(res);
                        //console.log('Estado de la respuesta:', res.status);
                        if (res.status == 200) 
                        {
                            return res.json();
                        }
                        else
                        {
                            throw new Error(`Error: ${res.status}`);
                        }

                        //return res.json();
                    })
                    .then(respuesta=>{
                        let dt={
                            'bien':()=>{                        
                                this.data_table();
                                $("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Compra removida`});
                            }
                        };

                        if(respuesta.mensaje in dt )
                        {
                            dt[respuesta.mensaje]();
                        }                
                    })
                    .catch(error=>{
                        this.funciones({nombre:'alerta',estatus:'error',mensaje:`La compra no se pudo remover`});
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;
                    });
                }
            });
        },
        boton_modal_editar_registro_evento(item)
        {        
            this.boton_modal_registro();
            this.datos.registro.id=item.target.getAttribute('registro-id');  
            this.datos.registro_cargando=true;  
            this.datos.registro.fecha_creacion='';  
            this.datos.registro.forma_pago='';  
            this.datos.registro.clientes_id='';
    
            fetch(`${this.general.otros.dominio_server}/compras/${this.datos.registro.id}/datos`,{
                method:'get',                
                headers:{                    
                    //'Content-Type':'application/json',
                    //'X-CSRF-TOKEN':this.general.otros.csrf
                    'Content-Type'  :'application/json',
                    'Accept'        :'application/json',
                    //'Authorization' :`Bearer ${this.general.otros.token}`
                },
                credentials: 'include',                   
            })
            .then(res=>res.json())
            .then(respuesta=>{

                let r=respuesta.datos.compra[0];

                this.datos.registro.clientes_id =r.clientes_id;
                this.datos.registro.total_compra_pre1=r.total_compra_pre1;
                this.datos.registro.total_compra=r.total_compra;
                this.datos.registro.estado      =r.estado;
                this.datos.registro.fecha_creacion=r.fecha_creacion;
                this.datos.registro.forma_pago  =r.forma_pago;
                this.datos.registro.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                this.datos.registro.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;

                r.productos.forEach((item,index)=>{
                    item.inventariar=item.inventariar==='si' ? true : false;
                    this.agregar_producto(item);
                });

                this.cliente_seleccionado('db');

                r.prestamos.forEach((item,index)=>{
                    this.prestamo_seleccionado(item);
                });

                r.transferencias.forEach((item,index)=>{
                    this.cuenta_bancaria_seleccionado(item);                        
                });

                this.calcular_forma_pago_efec_tran_total();

                

            })
            .catch(error=>{

            })
            .finally( () => {
                this.datos.registro_cargando=false;
            });
            
        },                
        agregar_producto(p)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});

            this.datos.registro.productos.push({
                id          :p==='' ? '' : p.id,
                productos_id:p==='' ? '' : p.productos_id,
                precio      :p==='' ? '' : p.precio,
                cantidad    :p==='' ? '' : p.cantidad,
                total       :p==='' ? '' : p.total,
                inventariar :p==='' ? true :  p.inventariar,
                posicion    :'',
                estado      :'activo'
            });
            this.productos_ordenar_posiciones();
            
            this.actualizar_select_material(this.datos.registro.productos.length-1,p);
            this.desactivar_scroll_cantidad_precio(this.datos.registro.productos.length-1);
        },
        boton_remover_producto(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.productos[index].estado='inactivo';
            this.productos_ordenar_posiciones();
            this.calcular_registro_compra_total();
        },
        productos_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro.productos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        },

        ////////////////
        material_seleccionado(index)
        {
            let p=this.datos.registro.productos[index];
            let a=(this.datos.productos.todos).find((e)=>e.id==p.productos_id);
            p.precio=a===undefined ? 0 : a.precio;

            document.getElementById('input_cantidad_'+index).focus();

            this.calcular_producto_total(index);
        },
        calcular_producto_total(index)
        {
            let p=this.datos.registro.productos[index];
            p.total=calculos.calcular_multiplicacion([
                p.precio,
                p.cantidad
            ]);
            p.total=(p.total).toFixed(2);
            this.calcular_registro_compra_total();
        },
        calcular_registro_compra_total()
        {
            let r=this.datos.registro;
            r.total_compra_pre1=0;
            //r.total_compra=0;

            (r.productos).forEach((p,index)=>{

                if(p.estado=='activo')
                {                                    
                    /* r.total_compra=calculos.calcular_suma([
                        r.total_compra,
                        p.total
                    ]); */
                    r.total_compra_pre1=calculos.calcular_suma([
                        r.total_compra_pre1,
                        p.total
                    ]);
                }
            });
            this.calcular_total_compra_menos_abonos();
            console.log(this.datos.registro);
        },
        guardar_localmente()
        {
            let r=this.datos.registro;            
            let db = new PouchDB('metales_milenio_2024_compras');
            
            if(r._id==='')
            {
                let registro = {
                    _id: new Date().toISOString(),
                    sincronizado: false,

                    id                          :r.id,
                    clientes_id                 :r.clientes_id,
                    fecha_creacion              :r.fecha_creacion,
                    prestamos                   :r.prestamos,
                    productos                   :r.productos,
                    total_compra_pre1           :r.total_compra_pre1,
                    total_compra                :r.total_compra,
                    forma_pago                  :r.forma_pago,
                    forma_pago_efe_tra_cant_efec:r.forma_pago_efe_tra_cant_efec,
                    forma_pago_efe_tra_cant_tran:r.forma_pago_efe_tra_cant_tran,
                    transferencias              :r.transferencias,
                    estado                      :r.estado                
                };

                db.put(registro).then( () => {                                                
                
                    this.data_table();
                    this.funciones({nombre:'alerta',estatus:'success',mensaje:`Compra guardada localmente`});
                    $("#modal-registro").modal("hide");                        
                    
                });
            }
            else
            {
                db.get(r._id)
                .then( (doc) => {                
                    //doc.sincronizado=false;

                    doc.id                          =r.id;
                    doc.clientes_id                 =r.clientes_id;
                    doc.fecha_creacion              =r.fecha_creacion;
                    doc.prestamos                   =r.prestamos;
                    doc.productos                   =r.productos;
                    doc.total_compra_pre1           =r.total_compra_pre1;
                    doc.total_compra                =r.total_compra;
                    doc.forma_pago                  =r.forma_pago;
                    doc.forma_pago_efe_tra_cant_efec=r.forma_pago_efe_tra_cant_efec;
                    doc.forma_pago_efe_tra_cant_tran=r.forma_pago_efe_tra_cant_tran;
                    doc.transferencias              =r.transferencias;
                    doc.estado                      =r.estado;

                    db.put(doc)
                    .then( () => {
                        //this.data_table_movilidad();
                        this.data_table();
                        this.funciones({nombre:'alerta',estatus:'success',mensaje:`Compra guardada localmente`});
                        $("#modal-registro").modal("hide");                        
                    });

                });  
            }            
        },

        enviar_datos(a)
        {
            let enviar=false;
            let veri_transferencias=false;

            if(a=='finalizar')
            {
                if(this.datos.registro.forma_pago=='efectivo_transferencia' && this.datos.forma_pago_efec_tran_cantidad_valida)
                {       
                    /*
                        este if verifica que si la forma de pago es efectivo junto con
                        transferencia, las suma de las cantidades en efectivo y transferencia
                        sean igual al total final de la compra
                    */             
                    enviar=true;
                }
                else if(['efectivo','transferencia'].includes(this.datos.registro.forma_pago))
                {
                    
                    enviar=true;                    
                }

                if( this.datos.registro.forma_pago=='transferencia')
                {
                    let transferencias_activas=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' );

                    let trans_total=0;
                    transferencias_activas.forEach((t,index)=>{
                        trans_total=calculos.calcular_suma([
                            trans_total,
                            t.cantidad
                        ]);
                    });
                    veri_transferencias=trans_total==this.datos.registro.total_compra ? true : false;
                }
                else if(this.datos.registro.forma_pago=='efectivo_transferencia')
                {
                    let transferencias_activas=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' );

                    let trans_total=0;
                    transferencias_activas.forEach((t,index)=>{
                        trans_total=calculos.calcular_suma([
                            trans_total,
                            t.cantidad
                        ]);
                    });

                    let forma_pago_efe_tra_cant_tran=calculos.revisar_numero(this.datos.registro.forma_pago_efe_tra_cant_tran);
                    veri_transferencias=trans_total==forma_pago_efe_tra_cant_tran ? true : false;

                }
                else if(this.datos.registro.forma_pago=='efectivo')
                {
                    veri_transferencias=true;
                }

            }
            else
            {
                enviar=true;
                veri_transferencias=true;
            }

            if(enviar && veri_transferencias)
            {

                this.alerta({titulo:'Procesando datos',mensaje:'espere ...'});  
                
                let p=this.datos.registro.productos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='') );

                p.forEach((item)=>{
                    item.inventariar_seleccionado=item.inventariar ? 'si' : 'no';
                });

                let prest=this.datos.registro.prestamos.filter((e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='') );

                /* 
                id          :'',
                prestamos_id:p,
                cantidad    :r.cantidad,
                saldo_pagar :r.saldo_pagar,
                abono       :0,
                estado      :'activo',
                posicion    :'' */
                let prestamos=[];
                prest.forEach((item,index)=>{
                    prestamos.push({
                        id              :item.id,
                        prestamos_id    :item.prestamos_id,
                        abono           :item.abono,
                        estado          :item.estado,
                        posicion        :item.posicion
                    });
                });

                let transferencias=(this.datos.registro.transferencias).filter( (e)=>e.estado=='activo' || (e.estado=='inactivo' && e.id!=='' ) );                
                                          
                fetch(`${this.general.otros.dominio_server}/compras/registro`,{
                    method:'POST',
                    body:JSON.stringify( {
                        accion      :a,
                        id          :this.datos.registro.id,
                        clientes_id :this.datos.registro.clientes_id,
                        fecha_creacion:this.datos.registro.fecha_creacion,
                        productos   :p,
                        prestamos   :prestamos,
                        total_compra_pre1:this.datos.registro.total_compra_pre1,
                        total_compra:this.datos.registro.total_compra,
                        forma_pago  :this.datos.registro.forma_pago,
                        forma_pago_efe_tra_cant_efec :this.datos.registro.forma_pago_efe_tra_cant_efec,
                        forma_pago_efe_tra_cant_tran :this.datos.registro.forma_pago_efe_tra_cant_tran,
                        transferencias  :transferencias
                    } ),
                    headers:{                    
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                        'Content-Type'  :'application/json',
                        'Accept'        :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                    },
                    credentials: 'include',                   
                })
                .then(res => {
                    if (res.status == 200) 
                    {
                        return res.json();
                    }
                    else
                    {
                        throw new Error(`Error: ${res.status}`);
                    }
                })
                //.then(res=>res.json())
                .then(respuesta=>{
                    let dt={
                        'bien':()=>{                                                           
                            
                            if(a=='finalizar')
                            {
                                if(this.datos.imprimir_ticket_al_finalizar)
                                {
                                    let clave=respuesta.datos.clave_visualizar;
                                    //${this.general.otros.dominio}/#/compras/${data.clave_visualizar}/ticket   
                                    // Abre la URL en una nueva pestaña
                                    if(clave!=='')
                                    {                                
                                        //window.open(`${this.general.otros.dominio}/#/compras/${clave}/ticket`, '_blank');
                                        let u=`${this.general.otros.dominio}/#/compras/${clave}/ticket`;
                                        document.getElementById('contenedor-impresion-ticket').innerHTML=`
                                            <iframe src=${u}></iframe>
                                        `;

                                    }
                                }
                            }

                            /*en caso de que el registro que se guardo 
                            era un registro offline*/
                            if(this.datos.registro._id!=='')
                            {   
                                this.registro_offline_sincronizado();
                            }
                            else
                            {
                                this.data_table();
                                $("#modal-registro").modal("hide");
                                this.funciones({nombre:'alerta',estatus:'success',mensaje:`Compra ${this.datos.registro.id=='' ? 'creada' : 'editada'}`});
                            }                            
                            
                        },
                        'abono supera el saldo':()=>{
                            this.funciones({nombre:'alerta',estatus:'error',mensaje:`Un abono supera el saldo restante`});
                        }
                    };

                    if(respuesta.mensaje in dt )
                    {
                        dt[respuesta.mensaje]();
                    }                
                })
                .catch(error=>{
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`La compra no se pudo ${this.datos.registro.id=='' ? 'crear' : 'editar'}`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;
                });
                

            }
            else
            {
                if(!enviar)
                {
                    this.funciones({
                        nombre:'alerta',estatus:'error',
                        mensaje:`
                            La compra no puede finalizar porque las cantidades de 
                            efectivo y transferencia no coinciden con el total final
                        `
                    });
                }
                else if(!veri_transferencias)
                {
                    this.funciones({
                        nombre:'alerta',estatus:'error',
                        mensaje:`
                            La compra no puede finalizar porque las transferencias no coinciden
                        `
                    });
                }
            }

        },
        registro_offline_sincronizado()
        {            
            let db = new PouchDB('metales_milenio_2024_compras');
            db.get(this.datos.registro._id)
            .then( (doc) => {                
                doc.sincronizado=true;
                //db.put(doc);
                db.put(doc)
                .then( () => {
                    //this.data_table_movilidad();
                    this.data_table();
                    $("#modal-registro").modal("hide");
                    this.funciones({nombre:'alerta',estatus:'success',mensaje:`Compra ${this.datos.registro.id=='' ? 'creada' : 'editada'}`});
                });
            })  
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        },
        cliente_seleccionado(p)
        {
            let c=this.datos.registro.clientes_id;
            if(c!=='')
            {
                this.datos.clientes.prestamos.cargando=true;
                this.datos.clientes.prestamos.todos=[];
                this.datos.clientes.prestamos.seleccionado='';

                if(this.datos.registro.id==='')
                {
                    this.datos.registro.prestamos=[];
                }
                else
                {
                    this.datos.registro.prestamos.forEach((item,index)=>{
                        item.estado='inactivo';
                    });
                }

                /* fetch(`${this.general.otros.dominio_server}/compras/clientes/${c}/prestamos`,{
                    method:'GET',
                    //body:JSON.stringify( this.datos.registro ),
                    headers:{
                        'Accept'        :'application/json',
                        'Content-Type'  :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                    },
                    credentials: 'include',                   
                })
                .then(res=>res.json())
                .then(respuesta=>{
                    
                    this.datos.clientes.prestamos.todos=respuesta.datos.prestamos;
                    if(p==='')
                    {
                        this.calcular_total_compra_menos_abonos();
                    }
                    

                })
                .catch(error=>{
                    //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;  
                    this.datos.clientes.prestamos.cargando=false;              
                }); */
            }
        },
        prestamo_seleccionado(d)
        {
            //datos.clientes.prestamos.seleccionado
            let p=d==='' ? this.datos.clientes.prestamos.seleccionado : d.prestamos_id;
            if(p!=='')
            {
                fetch(`${this.general.otros.dominio_server}/compras/prestamos/${p}/datos`,{
                    method:'GET',
                    //body:JSON.stringify( this.datos.registro ),
                    headers:{
                        'Accept'        :'application/json',
                        'Content-Type'  :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                    },
                    credentials: 'include',                   
                })
                .then(res=>res.json())
                .then(respuesta=>{                    
                    //console.log('prestamo datos');
                    //console.log(respuesta);
                    let r=respuesta.datos.prestamo[0];
                    this.datos.registro.prestamos.push({
                        id                              :d==='' ? '' : d.id,
                        prestamos_id                    :p,
                        cantidad                        :r.cantidad,
                        saldo_pagar                     :this.datos.registro.estado=='finalizado' ? d.saldo_antes_efectuar : r.saldo_pagar,
                        saldo_restante_despues_efectuar :this.datos.registro.estado=='finalizado' ? d.saldo_despues_efectuar : '',
                        abono                           :d==='' ? 0 : d.abono,
                        estado                          :'activo',
                        posicion                        :d==='' ? '' : d.posicion
                    });                    

                    this.datos.clientes.prestamos.seleccionado='';

                    if(d==='')
                    {
                        this.prestamos_ordenar_posiciones();
                    }
                    else
                    {
                        (this.datos.registro.prestamos).sort((a, b) => a.posicion - b.posicion);
                    }

                })
                .catch(error=>{
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos del prestamo`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;                
                });
            }
        },
        remover_prestamo(p_index)
        {
            this.datos.registro.prestamos[p_index].estado='inactivo';
            this.calcular_total_compra_menos_abonos();
            this.prestamos_ordenar_posiciones();
        },
        prestamos_ordenar_posiciones()
        {            
            let a=0;
            this.datos.registro.prestamos.forEach((item,index)=>{
                
                if(item.estado=='activo')
                {
                    a++;
                    item.posicion=a;
                }

            });
        },
        calcular_total_compra_menos_abonos()
        {
            let r=this.datos.registro;
            let total_abonos=0;

            r.prestamos.forEach((item,index)=>{
                if(item.estado=='activo')
                {
                    total_abonos=calculos.calcular_suma([
                        total_abonos,
                        item.abono
                    ]);
                }
            });

            r.total_compra=calculos.calcular_resta([
                r.total_compra_pre1,
                total_abonos
            ]);

            this.calcular_forma_pago_efec_tran_total();
            
        },
        
        precio_evento_key(event)
        {
            /*console.log('tecla 3');
            if($event.key=='Enter')
            {
                //this.agregar_producto('');
                document.getElementById(`input_cantidad_${index}`).focus();
            }*/
            console.log('tecla 3');
            if(event.key=='Enter')
            {
                this.agregar_producto('');
            }
        },   
        cantidad_evento_key($event,index)
        {
            /*console.log('tecla 3');
            if(event.key=='Enter')
            {
                this.agregar_producto('');
            }*/
            console.log('tecla 3');
            if($event.key=='Enter')
            {
                //this.agregar_producto('');
                document.getElementById(`precio_cantidad_${index}`).focus();
            }

        },
        evento_teclas(event)
        {
            console.log('abriendo modal');
            if(event.key=='Enter')
            {
                $("#modal-registro").modal('show');
            }
        },

        actualizar_select_material(index,p)
        {
            let id_intervalo=setInterval(()=>{

                let c=document.getElementById(`select_material_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;

                let dt={
                    //a:document.getElementById(`select_material_${index}`).options.length>0 ? ,
                    a:c,
                    b:((this.datos.productos.todos).length)+1    
                };
                /* console.log('here buscador');
                console.log(dt.a);
                console.log(dt.b);
                console.log('-------------------'); */

                if(dt.a==dt.b)
                {
                    $(`#select_material_${index}`).selectpicker();
                    $(`#select_material_${index}`).selectpicker('refresh');
                    clearInterval(id_intervalo);
                    if(p==='')
                    {                        
                        document.getElementById(`select_material_${index}`).focus();
                    }
                    else
                    {
                        document.getElementById(`input_cantidad_${index}`).focus();                        
                    }

                    /* let input = document.getElementById(`input_cantidad_${index}`);
                    input.addEventListener("wheel", function(event) {
                        console.log('evento here');
                        event.preventDefault(); // evita que el scroll cambie el valor
                    }); */
                    
                }

            },100);
        },
        desactivar_scroll_cantidad_precio(index)
        {
            let id_intervalo=setInterval(()=>{

                //let c=document.getElementById(`input_cantidad_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;                

                if(document.getElementById(`input_cantidad_${index}`)!==null)
                {                    
                    let input = document.getElementById(`input_cantidad_${index}`);
                    input.addEventListener("wheel", function(event) {
                        console.log('evento here');
                        event.preventDefault(); // evita que el scroll cambie el valor
                    });
                    clearInterval(id_intervalo);                    
                }

            },100);

            let id_intervalo2=setInterval(()=>{

                //let c=document.getElementById(`input_cantidad_${index}`)==null ? 0 : document.getElementById(`select_material_${index}`).options.length;                

                if(document.getElementById(`precio_cantidad_${index}`)!==null)
                {                    
                    let input2 = document.getElementById(`precio_cantidad_${index}`);
                    input2.addEventListener("wheel", function(event) {
                        console.log('evento here');
                        event.preventDefault(); // evita que el scroll cambie el valor
                    });
                    clearInterval(id_intervalo2);                    
                }

            },100);
        },
        calcular_forma_pago_efec_tran_total()
        {
            //this.datos.forma_pago_efec_tran_cantidad_valida
            let c=calculos.calcular_suma([
                this.datos.registro.forma_pago_efe_tra_cant_efec,
                this.datos.registro.forma_pago_efe_tra_cant_tran,
            ]);
            if(this.datos.registro.total_compra==c)
            {
                this.datos.forma_pago_efec_tran_cantidad_valida=true
            }
            else
            {
                this.datos.forma_pago_efec_tran_cantidad_valida=false;
            }
        },
        forma_pago_seleccionado()
        {
            this.datos.registro.forma_pago_efe_tra_cant_efec='';
            this.datos.registro.forma_pago_efe_tra_cant_tran='';
            this.datos.forma_pago_efec_tran_cantidad_valida=false;
        },
        cuenta_bancaria_seleccionado(c)
        {

            let id=c=='' ? this.datos.cuentas_bancarias.seleccionado : c.cuentas_bancarias_id;
            
            if(id!=='')
            {
                let a=this.datos.cuentas_bancarias.todos.find((e)=>e.cuentas_bancarias_id==id);
                console.log('a es');
                console.log(a);
                //if(a!==undefined)
                if(a===undefined)
                {                    
                    fetch(`${this.general.otros.dominio_server}/compras/cuentas_bancarias/${id}/datos`,{
                        method:'GET',
                        //body:JSON.stringify( this.datos.registro ),
                        headers:{
                            'Accept'        :'application/json',
                            'Content-Type'  :'application/json',
                            //'Authorization' :`Bearer ${this.general.otros.token}`
                            //'X-CSRF-TOKEN':this.general.otros.csrf
                        },
                        credentials: 'include',                   
                    })
                    .then(res=>res.json())
                    .then(respuesta=>{
                        
                        console.log('recursos');
                        console.log(respuesta);
                        if( (respuesta.datos).length>0 )
                        {
                            let d=respuesta.datos[0];
                            let banco_datos={
                                cuenta              :d.cuenta,
                                titular             :d.titular,
                                banco_nombre        :d.banco_nombre,
                                cuentas_bancarias_id:d.cuentas_bancarias_id
                            };
                            this.agregar_transferencia(c,banco_datos);
                        }
                    })
                    .catch(error=>{
                        //this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                        //this.datos.data_table.cargando=false;                
                    })
                    .finally( () => {
                        //this.datos.data_table.cargando=false;                
                    });
                }
                else
                {
                    /* this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
                    this.datos.registro.transferencias.push({
                        id          :c=='' ? '' : c.id,

                        cuenta      :a.cuenta,
                        titular     :a.titular,
                        banco_nombre:a.banco_nombre,

                        cuentas_bancarias_id    :c=='' ? a.cuentas_bancarias_id : c.cuentas_bancarias_id,
                        cantidad    :c=='' ? '' : c.cantidad,
                        estado      :'activo',
                        posicion    :''
                    }); */
                    this.agregar_transferencia(c,a);
                }
                this.datos.cuentas_bancarias.seleccionado='';
            }            
        },
        agregar_transferencia(c,a)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.agregar});
            this.datos.registro.transferencias.push({
                id          :c=='' ? '' : c.id,

                cuenta      :a.cuenta,
                titular     :a.titular,
                banco_nombre:a.banco_nombre,

                cuentas_bancarias_id    :c=='' ? a.cuentas_bancarias_id : c.cuentas_bancarias_id,
                cantidad    :c=='' ? '' : c.cantidad,
                estado      :'activo',
                posicion    :''
            });
        },
        remover_transferencia(index)
        {
            this.funciones({nombre:'sonido',sonido:this.general.sonidos.remover});
            this.datos.registro.transferencias[index].estado='inactivo';
        }

    },
    computed: {
        ...mapState(['general']),
        ...mapGetters([
            'general_fecha_hoy',
            'general_no_xss',
            'general_formato_moneda'
        ]),
        /* ...mapGetters(['formatear_moneda']),
        formato_moneda(m)
        {
            this.formatear_moneda(m);
        } */        
    },
    watch: {
        'general.otros.autenticado': function (v) {
            if(v)
            {
                this.inicial();
            }
        }
    }
}
</script>

<style lang="scss" scoped>        
    .contenedor-producto{
        background:linear-gradient(90deg, #0093ff, #484848);
        border-radius:7px; 
        margin-bottom:1em; 
        padding:1em;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.8);
        padding-bottom:0px; 
        padding-top:0.5em;

        /* &:hover{
            background:linear-gradient(90deg, #01253f, #1d1c1c);
        } */

        label {
            color:white;
        }
    }
    #leyenda-metodo-pago-ambos-rojo{
        color:red;
    }
    #leyenda-metodo-pago-ambos-verde{
        color:green;
    }

    #modal-compras-footer{
        display:flex;
        flex-wrap:wrap;        
        #modal-compras-footer-botones{
            width:45%;
            display:flex;
            justify-content:right;
        }
        #modal-compras-footer-imprimir{
            width:45%;
            display:flex;
            flex-wrap:wrap;
            align-items:center;            
            justify-content:right;
            padding-right:4%;
            input{
                width:30px;
                margin-right:1em;
            }
            p{
                margin:0px;
            }
        }
    }

    #select_cuentas_disponibles{
        option{
            text-align:left;
        }
    }

    .material-total{
        color:white;
        /* font-family:math; */
        text-align:center;
        font-size:1em;
        width:100%;
    }

    .titulo-campo{
        width:100%;
        text-align:center;
    }

    .valor-campo{
        text-align:center;
    }

    .material-nombre{
        color:white; 
        text-align:center; 
        margin:0px; 
        font-size:1em;
        cursor:pointer;
        &:hover{
            background:red;
            border-radius:7px;
            padding:0.5em;
        }
    }

</style>